import { Subject } from "rxjs";
import { RegistrationRequest } from "src/app/view-models/registration-request";
import * as i0 from "@angular/core";
export class RegistrationService {
    constructor() {
        this.currentActiveIndex = 0;
        this.isRegistrationComplete = false;
        this.auth0Context = null;
        // Persisted in sessionStorage so the Auth0 "create a new account" flow survives a page refresh
        // (the in-memory wizard state would otherwise be lost and the page would look like a normal
        // public registration). sessionStorage keeps it scoped to the current tab/session.
        this.auth0ContextStorageKey = 'auth0RegistrationContext';
        // Set when the just-completed registration was the Auth0 create-and-link flow, so the success
        // page can show an Auth0-appropriate message (no set-password email is sent in that case).
        this.isAuth0Registration = false;
        this.indexSubject = new Subject();
        this.indexObservable = this.indexSubject.asObservable();
    }
    updateInfo(registrationRequest) {
        this.registrationInformation = Object.assign({}, this.registrationInformation, registrationRequest);
    }
    clearInformation() {
        this.registrationInformation = new RegistrationRequest();
        this.clearAuth0Context();
    }
    setAuth0Context(context) {
        this.auth0Context = context;
        try {
            sessionStorage.setItem(this.auth0ContextStorageKey, JSON.stringify(context));
        }
        catch ( /* sessionStorage unavailable (e.g. SSR) — in-memory value still applies */_a) { /* sessionStorage unavailable (e.g. SSR) — in-memory value still applies */ }
    }
    getAuth0Context() {
        // Re-hydrate from sessionStorage after a page refresh, when the in-memory value is gone.
        if (!this.auth0Context) {
            try {
                const raw = sessionStorage.getItem(this.auth0ContextStorageKey);
                if (raw) {
                    this.auth0Context = JSON.parse(raw);
                }
            }
            catch ( /* sessionStorage unavailable or bad JSON — treat as no context */_a) { /* sessionStorage unavailable or bad JSON — treat as no context */ }
        }
        return this.auth0Context;
    }
    clearAuth0Context() {
        this.auth0Context = null;
        try {
            sessionStorage.removeItem(this.auth0ContextStorageKey);
        }
        catch ( /* sessionStorage unavailable — nothing to clear */_a) { /* sessionStorage unavailable — nothing to clear */ }
    }
    setIsAuth0Registration(value) {
        this.isAuth0Registration = value;
    }
    getIsAuth0Registration() {
        return this.isAuth0Registration;
    }
    getRegistrationInformation() {
        return this.registrationInformation;
    }
    setCurrentActiveIndex(activeIndex) {
        this.currentActiveIndex = activeIndex;
    }
    getCurrentActiveIndex() {
        return this.currentActiveIndex;
    }
    setIndex(index) {
        this.indexSubject.next(index);
    }
    getIndexAsObservable() {
        return this.indexObservable;
    }
    getIsRegistrationComplete() {
        return this.isRegistrationComplete;
    }
    setIsRegistrationComplete(isCompleted) {
        this.isRegistrationComplete = isCompleted;
    }
}
RegistrationService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function RegistrationService_Factory() { return new RegistrationService(); }, token: RegistrationService, providedIn: "root" });
